import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
const TITLE = "Gregorian to Hijri Converter";
const DESCRIPTION = "Convert date from Gregorian to Hijri by entering the Gregorian date and finding its equivalent in Hijri using the electronic date converter.";
const KEYWORDS = "Convert date, Gregorian, Hijri, Enter date, Electronic date converter, Equivalent, Gregorian date conversion to Hijri, Electronic, Date conversion";
const OG_URL = 'https://do-calculate.com/calculator/en/gregorian_to_hijri';
function ConversionToHijri() {
  const [gregorianDate, setGregorianDate] = useState("");
  const [hijriDate, setHijriDate] = useState("");
  const [showError, setShowError] = useState(false);
  const handleDateChange = (event) => {
    const { value } = event.target;
    setGregorianDate(value);
    setHijriDate("");
  };
  const convertToHijri = () => {
    const currentDate = moment().format("YYYY-MM-DD");
    const isValidDate = moment(gregorianDate, "YYYY-MM-DD", true).isValid();
    if (
      isValidDate &&
      moment(gregorianDate).isSameOrBefore(currentDate) &&
      moment(gregorianDate).year() > 1937
    ) {
      const convertedDate = getHijriDate(gregorianDate);
      setHijriDate(convertedDate);
      setShowError(false);
    } else {
      setHijriDate("");
      setShowError(true);
    }
  };
  const getHijriDate = (date) => {
    const hijri = moment(date, "YYYY-MM-DD").format("iYYYY-iM-iD");
    return hijri;
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  This online calculator provides an easy way to convert dates from the Gregorian to the Hijri calendar. Simply, the user selects the conversion direction and enters the desired Gregorian date. Then, the calculator automatically performs the conversion and presents the converted date in the Hijri calendar. The result is displayed in two formats: the first in a digital format, and the second by detailing the day, month, and year. This calculator allows users to quickly and accurately obtain converted dates between the Gregorian and Hijri calendars, making it easy to organize times and events in daily life.
                </p>
                <br />
                <p>
                  Through this calculator, you can enter the date in the Gregorian format, and it will convert the entered date to its equivalent in the Arabic Hijri calendar according to the Umm al-Qura calendar.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <label
                  htmlFor="dateOfBirth"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  Enter the Gregorian Date
                </label>
              </div>
              <div className="col">
                <div className="form-group">
                  <input
                    type="date"
                    id="gregorianDate"
                    value={gregorianDate}
                    onChange={handleDateChange}
                    className="form-control"
                    lang="ar"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col text-center">
                <br />
                <Button
                  variant="contained"
                  color="success"
                  onClick={convertToHijri}
                  disabled={!showError}
                  sx={{
                    fontSize: {
                      md: "17px",
                    },
                    mt: "25px",
                    mb: "10px",
                  }}
                >
                  Calculate
                </Button>
              </div>
              <div className="row">
                {showError && (
                  <p style={{ color: "red" }}>
                    Please enter a date between 1938 and the current date.
                  </p>
                )}
                <div className="col">
                  {hijriDate && !showError && (
                    <Fragment>
                      <hr style={{ margin: "0 0 1rem 0" }} />
                      <TableContainer
                        component={Paper}
                        style={{ marginBottom: "15px" }}
                      >
                        <Table style={{ marginBottom: "0" }}>
                          <TableHead>
                            <TableRow style={{ backgroundColor: "#4caf50" }}>
                              <TableCell
                                style={{
                                  color: "white",
                                  textAlign: "center",
                                  fontSize: "20px",
                                }}
                              >
                                Entered Date
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  textAlign: "center",
                                  fontSize: "20px",
                                }}
                              >
                                Equivalent in Hijri Date
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {gregorianDate}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {hijriDate}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fragment>
                  )}
                </div>
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.humanCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Convert Gregorian Date to Hijri</div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Convert Gregorian Date to Hijri Online</h2>{" "}
                </u>
                <br />
                <p>
                  The online calculator is an effective way to convert dates from the Gregorian to the Hijri calendar. For example, the application can convert the issue date of a passport from the Gregorian date, where the day is the twentieth, the month is the third, and the year is two thousand twenty. The converted date in the Hijri calendar will be displayed.
                  In another context, the application is used to record the expiration date of a credit card, where the day is the fifteenth, the month is the tenth, and the year is two thousand twenty in the Gregorian date.
                  Converting dates online allows for easy organization of times and schedules, whether for travel or finance, with quick and accurate access to results at any time and from anywhere in the world.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Steps for Date Conversion</h2>
                </u>
                <br />
                <p>Convert the date from Hijri to Gregorian and vice versa correctly, God willing. Just choose the conversion method. For example, if you want to convert the Hijri date to the Gregorian date, simply click on the "Convert Hijri Date" statement, then choose the day, month, and year, then convert. After that, the site will automatically determine the correct date according to the calendar you chose by changing the country or selecting the Umm al-Qura calendar, and the same applies to converting the date from Gregorian to Hijri by following the same steps mentioned above.</p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Practical Application and Example of Converting Dates from the Gregorian to the Hijri Calendar</h2>
                </u>
                <br />
                <p>
                  An effective application for converting dates from the Gregorian to the Hijri calendar, where the example displays the birth date of a person born in a foreign country on 15/9/2020. This date needs to be converted to the Hijri calendar to register the newborn in Saudi Arabia, for example. By entering the day 15, month 9, and year 2020 into the conversion system, the converted date will appear in various formats, such as 1442-01-28 or 28 Muharram 1442, completing the process successfully.
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
         </div>
</div>
  );
}
export default ConversionToHijri;
